import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {getPollPortalToken} from "../actions/pollPortal/pollPortalAction";

class PortalAuthContainer extends React.Component {

    constructor(props) {
        super(props);
    }

    componentWillMount() {
        this.props.getPortalToken(this.props.match.params.nonce);
    }

    render() {
        const {redirectTo, status} = this.props;

        if (status === "PortalInfoReceived") {
            if (redirectTo === null || redirectTo === undefined || redirectTo.length === 0) {
                this.props.history.push('/notfound');
            } else {
                window.location.replace(redirectTo);
            }
        }

        return (
            <div/>
        );
    }
}

PortalAuthContainer.propTypes = {
    getPortalToken: PropTypes.func,
    status: PropTypes.string,
    redirectTo: PropTypes.string,
    history: PropTypes.object,
    match: PropTypes.object
};

function mapDispatchToProps(dispatch) {
    return {
        getPortalToken: (nonce) => dispatch(getPollPortalToken(nonce))
    };
}

function mapStateToProps(state) {
    return {
        status: state.pollPortal.status,
        redirectTo: state.pollPortal.redirectTo
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PortalAuthContainer));
